import { CancelOutlined, CheckCircleOutline, ScheduleSharp } from "@material-ui/icons"
import moment from "moment"

export const activityStatuses = {
  scheduled: {
    name: "Scheduled",
    icon: (date) => <ScheduleSharp style={{ fontSize: '14px', color: (date && moment(date)?.isBefore(moment(Date.now()))) ? "red" : "#ff6f00" }} />,
    color: "#ff6f00",
    colorPast: (date) => moment(date)?.isBefore(moment(Date.now())) ? "red" : "#ff6f00",
    calendarTextColor: (date) => moment(date)?.isBefore(moment(Date.now())) ? "red" : "#ff6f00",
    styleText: {}
  },
  completed: undefined,
  // {
  //   name: "Completed",
  //   icon: (date) => <CheckCircleOutline style={{ fontSize: '14px', color: 'green' }} />,
  //   color: "green",
  //   colorPast: (date) => moment(date).isBefore ? "red" : "green",
  //   calendarTextColor: (date) => moment(date)?.isBefore(moment(Date.now())) ? "red" : "grey"
  //  styleText: {}
  // },
  canceled: {
    name: "Canceled",
    icon: (date) => <CancelOutlined style={{ fontSize: '14px', color: "grey" }} />,
    color: "red",
    colorPast: (date) => moment(date).isBefore ? "grey" : "red",
    calendarTextColor: (date) => moment(date)?.isBefore(moment(Date.now())) ? "grey" : "grey",
    styleText: {textDecoration: 'line-through'}
  }
}
